import { jsx as _jsx } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router';
import { finishInvitation } from '../actions/api';
import * as types from '../constants/ActionTypes';
import withGTag from '../components/withGTag';
import { GOOGLE_ANALYTICS_ID, WEBSITE_URL } from '../constants/env';
import WebsiteDataShare from '../model/WebsiteDataShare';
import ApiV2ModelContext from '../contexts/ApiV2ModelContext';
export class Authenticator extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            loadTimeout: null,
        };
    }
    async componentDidMount() {
        const { match, user, checkLogin, dispatch } = this.props;
        let token = null;
        const params = window.location.hash.split('&');
        if (params.length > 0 && params[0].startsWith('#access_token=')) {
            token = decodeURIComponent(params[0].replace('#access_token=', ''));
        }
        else if (localStorage.getItem('token')) {
            token = localStorage.getItem('token');
        }
        if (match &&
            /^\/login/.test(match.path) &&
            new URL(location.href).searchParams.get('invitationToken')) {
            localStorage.setItem('invitationToken', new URL(location.href).searchParams.get('invitationToken') || '');
        }
        token = token && token !== user.token ? token : user.token;
        if (token && !user.loggedIn) {
            await this.authenticate(token, params.includes('firstLogin=true'));
        }
        else if (checkLogin && !user.loggedIn) {
            if (!localStorage.getItem('loginRedirectUrl') ||
                /\/login(.*)?/.test(localStorage.getItem('loginRedirectUrl') || '')) {
                if (new URL(location.href).searchParams.get('plan') === 'pro') {
                    localStorage.setItem('loginRedirectUrl', '/settings/billing');
                }
                else {
                    localStorage.setItem('loginRedirectUrl', match.url);
                }
            }
            dispatch({ type: types.UNAUTHENTICATED_USER });
        }
        const ghaInstallation = params.find(param => param.startsWith('ghaInstallation='));
        if (ghaInstallation) {
            const ghaInstallationName = ghaInstallation ? ghaInstallation.split('=')[1] : '';
            dispatch({ type: types.SET_GHA_INSTALLATION, payload: ghaInstallationName });
            dispatch({ type: types.SET_REPOSITORY_SEARCH, payload: ghaInstallationName });
        }
    }
    componentWillUnmount() {
        if (this.state.loadTimeout) {
            clearTimeout(this.state.loadTimeout);
        }
    }
    async authenticate(token, firstLogin) {
        this.props.dispatch({
            type: types.AUTHENTICATING_USER,
            payload: { token, firstLogin },
        });
        await this.loadUserData(true, token);
    }
    async loadUserData(initial = false, token) {
        const { user, gtag, dispatch, match } = this.props;
        try {
            const oldToken = localStorage.getItem('token');
            if (token) {
                localStorage.setItem('token', token);
            }
            const userResponse = await this.context.getMe(dispatch);
            const potentialUser = user.user || userResponse;
            if (potentialUser && (potentialUser.isLoadingPrOrRepositories || potentialUser.fetchedPullRequestsProgress === null)) {
                this.setState({
                    // @ts-expect-error TS2322: Type 'Timeout' is not assignable to type 'number'.
                    loadTimeout: setTimeout(() => this.loadUserData(), 3000),
                });
            }
            if (!initial) {
                return;
            }
            // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            this.shareTokenWithWebsite(token, oldToken);
            gtag('config', GOOGLE_ANALYTICS_ID, { user_id: userResponse.id }); // eslint-disable-line camelcase
            this.finishInvitation();
        }
        catch (error) {
            console.error(error);
            if (!localStorage.getItem('loginRedirectUrl') || localStorage.getItem('loginRedirectUrl') === '/') {
                localStorage.setItem('loginRedirectUrl', match.url);
            }
            dispatch({ type: types.UNAUTHENTICATED_USER });
        }
    }
    shareTokenWithWebsite(token, oldToken) {
        if (WEBSITE_URL && oldToken !== token) {
            const websiteDataShare = new WebsiteDataShare();
            websiteDataShare.storeToken(token);
        }
    }
    finishInvitation() {
        if (!localStorage.getItem('invitationToken')) {
            return;
        }
        this.props
            .dispatch(finishInvitation(localStorage.getItem('invitationToken') || ''))
            .then(async (invitationAction) => {
            if (invitationAction.type === types.FINISH_INVITATION_SUCCESS) {
                this.props.dispatch({
                    type: types.SET_INVITED_ORGANIZATION,
                    payload: invitationAction.response.data,
                });
                try {
                    await this.context.getMe(this.props.dispatch);
                }
                catch (error) {
                    console.error(error);
                }
                localStorage.removeItem('invitationToken');
            }
            else {
                this.props.dispatch({
                    type: types.SET_INVITED_ORGANIZATION,
                    payload: null,
                });
                localStorage.removeItem('invitationToken');
                console.error(invitationAction);
            }
        });
    }
    render() {
        const { match, user, checkLogin } = this.props;
        if (checkLogin && user.unauthenticated && (!match || !/\/login(\/:slug)?/.test(match.path))) {
            return _jsx(Redirect, { to: `/login` + (match && match.params.vcs ? '/' + match.params.vcs : '') });
        }
        return null;
    }
}
Authenticator.contextType = ApiV2ModelContext;
Authenticator.defaultProps = {
    checkLogin: false,
};
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch,
});
export default withGTag(connect(mapStateToProps, mapDispatchToProps)(Authenticator));
